import api from "./api.js";

export default class ColumnApi {
  static async getCategory(data) {
    return await api.get(`column-category`, data);
  }
  static async getCategoryById(id, data) {
    return await api.get(`column-category/${id}`, data);
  }
  static async addCategory(data) {
    return await api.post(`column-category`, data);
  }
  static async editCategory(id, data) {
    return await api.patch(`column-category/${id}`, data);
  }
  static async updateActivation(id, data) {
    return await api.patch(`column-category/activation/${id}`, data);
  }
  static async delcategory(data) {
    return await api.del(`column-category`, data);
  }
  static async getPost(data) {
    return await api.get(`column-post`, data);
  }
  static async getPostById(id, data) {
    return await api.get(`column-post/${id}`, data);
  }
  static async addPost(data) {
    return await api.post(`column-post`, data);
  }
  static async postActivation(id, data) {
    return await api.patch(`column-post/activation/${id}`, data);
  }
  static async delPost(data) {
    return await api.del(`column-post`, data);
  }
  static async updatePost(id, data) {
    return await api.patch(`column-post/${id}`, data);
  }
  static async getComment(data) {
    return await api.get(`column-comment`, data);
  }
  static async delComment(data) {
    return await api.del(`column-comment`, data);
  }
}
